import { gql } from "apollo-boost";

const UPDATE_PRODUCT_LAKE_INFORMATION = gql`
  mutation updateProductLakeInformation($input: UpdateProductLakeInformation) {
    updateProductLakeInformation(input: $input) {
      data
      error
      status
    }
  }
`;
export default UPDATE_PRODUCT_LAKE_INFORMATION;
